<template>
  <div class="insurance-rule-page">
    <div class="summary-row">
      <div class="summary-card">
        <div class="summary-title">全职司机</div>
        <div class="summary-price">¥{{ formData.full_fee }}/月</div>
        <div class="summary-tip">每月从服务费账户扣取的全职司机固定费用</div>
      </div>
       <div class="summary-card">
        <div class="summary-title">兼职司机</div>
        <div class="summary-price">¥{{ formData.part_fee }}/次</div>
        <div class="summary-tip">{{ getTriggerTip('part') }}</div>
      </div>
       <div class="summary-card">
        <div class="summary-title">按单司机</div>
        <div class="summary-price">¥{{ formData.single_fee }}/次</div>
        <div class="summary-tip">{{ getTriggerTip('single') }}</div>
      </div>
    </div>

    <div class="section-panel">
      <div class="section-header">全职司机</div>
      <div class="section-body">
        <div class="section-row">
          <div class="field-label">月费金额（元/人/月）</div>
          <div class="field-input">
            <el-input v-model="formData.full_fee" type="number" :min="0" disabled/>
          </div>
          <div class="field-note">每月从服务费账户扣取的全职司机固定费用</div>
        </div>

        <!-- <div class="section-row">
          <div class="field-label">统一扣费日</div>
          <div class="field-input">
            <el-select v-model="formData.settle_day" placeholder="请选择" style="width: 100%">
              <el-option label="每月1号" :value="1" />
              <el-option label="每月10号" :value="10" />
              <el-option label="每月15号" :value="15" />
              <el-option label="每月20号" :value="20" />
            </el-select>
          </div>
          <div class="field-note">系统在此日期统一扣取当月全职月费</div>
        </div> -->
      </div>
    </div>

    <div class="section-panel">
      <div class="section-header">兼职司机</div>
      <div class="section-body">
        <div class="section-row">
          <div class="field-label">单次服务费（元/次）</div>
          <div class="field-input">
            <el-input v-model="formData.part_fee" type="number" :min="0" disabled/>
          </div>
          <div class="field-note">{{ getTriggerTip('part') }}</div>
        </div>

        <div class="section-row">
          <div class="field-label">扣费触发条件</div>
          <div class="field-input">
            <el-select v-model="formData.part_trigger" placeholder="请选择" style="width: 100%" disabled>
              <el-option label="开始服务" :value="1" />
              <el-option label="支付成功" :value="2" />
            </el-select>
          </div>
          <div class="field-note">触发服务费扣费的时机</div>
        </div>
      </div>
    </div>

    <div class="section-panel">
      <div class="section-header">按单司机</div>
      <div class="section-body">
        <div class="section-row">
          <div class="field-label">单次服务费（元/次）</div>
          <div class="field-input">
            <el-input v-model="formData.single_fee" type="number" :min="0" disabled/>
          </div>
          <div class="field-note">{{ getTriggerTip('single') }}</div>
        </div>

        <div class="section-row">
          <div class="field-label">扣费触发条件</div>
          <div class="field-input">
            <el-select v-model="formData.single_trigger" placeholder="请选择" style="width: 100%" disabled>
              <el-option label="开始服务" :value="1" />
              <el-option label="支付成功" :value="2" />
            </el-select>
          </div>
          <div class="field-note">触发服务费扣费的时机</div>
        </div>
      </div>
    </div>

    <!-- <div class="bottom-actions">
      <el-button @click="resetForm">重置</el-button>
      <el-button type="primary" @click="saveRule">保存</el-button>
    </div> -->
  </div>
</template>

<script>
var _this;
export default {
  data() {
    return {
      cityList: [],
      summaryCards: [
        { key: 'full', title: '全职司机', price: 80, unit: '月', tip: '按月结算' },
        { key: 'part', title: '兼职司机', price: 1, unit: '次', tip: '' },
        { key: 'single', title: '按单司机', price: 1, unit: '次', tip: '按单次服务时扣费' },
      ],
      formData: {
        full_fee: "",
        part_fee: "",
        single_fee: "",
        // settle_day: 1,
        part_trigger: 1,
        single_trigger: 1,
      },
    };
  },
  created() {
    _this = this;
    this.loadRule();
  },
  methods: {
    getTriggerTip(type) {
      const trigger = type === 'part' ? this.formData.part_trigger : this.formData.single_trigger;
      return trigger === 2 ? '支付成功后，从服务费账户扣取' : '开始服务时，从服务费账户扣取';
    },
    loadRule() {
      this.$post('/city_insurance/get', {
      })
        .then((res) => {
          const data = res.data.config || {};
          this.formData.full_fee = data.full_fee !== undefined ? Number(data.full_fee) : "";
          this.formData.part_fee = data.part_fee !== undefined ? Number(data.part_fee) : "";
          this.formData.single_fee = data.single_fee !== undefined ? Number(data.single_fee) : "";
          this.formData.part_trigger = data.part_trigger !== undefined ? Number(data.part_trigger) : 1;
          this.formData.single_trigger = data.single_trigger !== undefined ? Number(data.single_trigger) : 1;
          // this.formData.settle_day = data.settle_day || 1;
        })
        .catch((err) => {
          this.$message.error(err.msg || '收费规则加载失败');
        });
    },
    // saveRule() {
    //   this.$post('/city_insurance/edit', {
    //     full_fee: this.formData.full_fee,
    //     part_fee: this.formData.part_fee,
    //     single_fee: this.formData.single_fee,
    //     part_trigger: this.formData.part_trigger,
    //     single_trigger: this.formData.single_trigger,
    //     // settle_day: this.formData.settle_day,
    //   })
    //     .then((res) => {
    //       this.$message.success(res.msg || '保存成功');
    //     })
    //     .catch((err) => {
    //       this.$message.error(err.msg || '保存失败');
    //     });
    // },
    // resetForm() {
    //   this.loadRule();
    // },
  },
};
</script>

<style scoped>
.insurance-rule-page {
  padding: 24px 20px 40px;
  background: #f5f7fa;
  /* min-height: 100vh; */
  color: #303133;
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 22px;
}

.summary-card {
  text-align: center;
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 0 rgba(17, 24, 39, 0.02);
}

.summary-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.summary-price {
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
  margin-bottom: 8px;
}

.summary-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.section-panel {
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  margin-bottom: 18px;
  overflow: hidden;
}

.section-header {
  padding: 16px 20px;
  font-size: 15px;
  font-weight: 600;
  color: #2f3a4b;
  border-bottom: 1px solid #eef2f6;
  background: #fbfcfe;
}

.section-body {
  padding: 18px 20px 8px;
}

.section-row {
  display: grid;
  grid-template-columns: 220px 200px 1fr;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.field-label {
  font-size: 14px;
  color: #303133;
}

.field-input {
  width: 200px;
  min-width: 160px;
}

.field-note {
  font-size: 12px;
  color: #909399;
  text-align: left;
}

.bottom-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

:deep(.el-input__inner),
:deep(.el-input-number .el-input__inner),
:deep(.el-select .el-input__inner) {
  height: 38px;
  line-height: 38px;
  border-radius: 8px;
}

:deep(.el-button) {
  border-radius: 8px;
}

@media (max-width: 980px) {
  .summary-row {
    grid-template-columns: 1fr;
  }

  .section-row {
    grid-template-columns: 1fr;
  }
}
</style>
